<template functional>
  <div class="event" :class="props.event.eventType">
    <details>
      <summary :class="props.event.eventType">
        <span class="type">
          {{ props.icon }}
          {{ props.event.eventType }}
        </span>
        <span
          :title="props.user.email"
          class="email">
          <router-link
            :to="{ path: `/user/${props.user.email}` }">
              {{ props.user.email }}
          </router-link>
        </span>
        <span
          class="id"
          :title="props.serverOrigin">
          <router-link
            :to="{
              path:
                `/origin/${props.event.context.serverOrigin}/session/${props.session.id}` }">
                  {{ props.session.id }}
          </router-link>
        </span>
        <span class="timestamp">
          [{{ props.timestamp }}]
        </span>
      </summary>
      <div class="data">{{
        JSON.stringify(props.event.data, null, 2)}}</div>
    </details>
  </div>
</template>

<script>
export default {
  name: 'Event',
  props: {
    serverOrigin: String,
    session: Object,
    user: Object,
    icon: String,
    timestamp: String,
    event: Object
  }
}
</script>

<style scoped>

a {
  color: inherit;
}

.event.start_exam summary,
.event.syscheck_result summary {
  border-left: 4px solid #212121;
  border-radius-left: 0;
}

.event {
  margin-bottom: 10px;
}

.timestamp {
  color: #757575;
}

.email, .id {
  color: #757575;
}

.email {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 20px;
}

.data {
  padding: 20px;
  white-space: pre;
  word-break: break-all;

  max-width: 730px;
  overflow-x: auto;
  color: #424242;
}

summary {
  cursor: pointer;
  padding: 15px;

  transition: all 0.3s cubic-bezier(.25,.8,.25,1);

  display: grid;
  grid-template-columns: 200px 2fr 100px auto;

  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

details[open] {
  background-color: #f5f5f5;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

details[open] > summary {
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

details summary::-webkit-details-marker {
  display:none;
}

</style>
